import { Avatar, Col, Text } from 'components';
import { format, isThisYear } from 'date-fns';
import { capitalize, normalizeDate, theme } from 'lib';
import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TableComponents } from 'screens/Admin/components';

const ID_STATUS = {
  pendingAction: 'Pending action',
  pendingVerification: 'Pending verification',
  notVerified: 'Not verified',
  verifiedAndDismissed: 'Verified'
};

const ListItem = memo(({ item, onClick = null, dataId }) => {
  const [avatar, setAvatar] = useState(item.avatar);
  const isSelected = dataId === item._id;
  const { t } = useTranslation();
  const createdAt = item.createdAt ? new Date(item.createdAt) : null;
  const isValidDate = createdAt && !isNaN(createdAt.getTime());

  useEffect(() => {
    if (item.avatar === avatar) return;

    setAvatar(item.avatar);
  }, [item.avatar]);

  return (
    <TableComponents.Tr onClick={() => onClick(item._id)} isSelected={isSelected}>
      <TableComponents.Td isSelected={isSelected} first>
        <Col style={{ zIndex: -1, position: 'relative' }}>
          <Avatar user={item} avatar={avatar} tiny />
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Text>{item.name}</Text>
        <Text c1 col={theme.GREY_60}>
          @{item.username}
        </Text>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text>{item?.email?.includes('@') ? item.email : ''}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text>{capitalize(item.type || '')}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Text>{item?.verified?.email ? 'Verified' : 'Not verified'}</Text>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected} last>
        <Text>
          {item?.verified?.id
            ? 'Verified'
            : ID_STATUS[item?.verified?.idProgress] || 'Not verified'}
        </Text>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text>
            {isValidDate && (
              <>
                {isThisYear(createdAt) ? '' : `${format(createdAt, 'yyyy')} `}
                {normalizeDate(item.createdAt, null, t)}
              </>
            )}
          </Text>
        </Col>
      </TableComponents.Td>
    </TableComponents.Tr>
  );
});

export default ListItem;
